import { render } from "./delivery-issues.vue?vue&type=template&id=534ee1a5"
import script from "./delivery-issues.vue?vue&type=script&lang=js"
export * from "./delivery-issues.vue?vue&type=script&lang=js"

import exportComponent from "/home/eymekkjd/infos-projet.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__